import React from "react";
import { checkForOverride } from "../helpers/theme";
import { ReplaceWithDataSource } from "../helpers/variable";

export default function Checklist({ cue, baseTheme, baseThemeId }) {
	return (
		<>
			<span
				style={{
					fontFamily: baseTheme.h1?.font || baseTheme.font?.family,
					color: checkForOverride(
						baseTheme,
						cue.type,
						cue.preset,
						"h1",
						"colour"
					),
					fontWeight:
						checkForOverride(baseTheme, cue.type, cue.preset, "h1", "bold") ===
						true
							? "bold"
							: "normal",
					fontStyle:
						checkForOverride(
							baseTheme,
							cue.type,
							cue.preset,
							"h1",
							"italic"
						) === true
							? "italic"
							: "normal",
					textDecoration:
						checkForOverride(
							baseTheme,
							cue.type,
							cue.preset,
							"h1",
							"underline"
						) === true
							? "underline"
							: "none",
				}}
				className={`${baseThemeId}_${cue.type}_large_text large_text 
text-${checkForOverride(baseTheme, cue.type, cue.preset, "h1", "size")}

                    leading-${checkForOverride(
											baseTheme,
											cue.type,
											cue.preset,
											"h1",
											"leading"
										)}
                    `}
			>
				{<ReplaceWithDataSource text={cue.title} styled={true} />}
			</span>
			<span
				style={{
					color: checkForOverride(
						baseTheme,
						cue.type,
						cue.preset,
						"h2",
						"colour"
					),
				}}
				className={`w-full inline-block
    text-${checkForOverride(baseTheme, cue.type, cue.preset, "h2", "size")}
`}
			>
				<ol
					className={`flex flex-col mt-s2 list-inside
        ${`list-${baseTheme?.[cue.type]?.list_style || "none"}`}		
    `}
				>
					{cue.items.map((item, i) => {
						return (
							<li
								key={i}
								style={{
									fontFamily: baseTheme.h2?.font || baseTheme.font?.family,
									fontWeight:
										checkForOverride(
											baseTheme,
											cue.type,
											cue.preset,
											"h2",
											"bold"
										) === true
											? "bold"
											: "normal",
									fontStyle:
										checkForOverride(
											baseTheme,
											cue.type,
											cue.preset,
											"h2",
											"italic"
										) === true
											? "italic"
											: "normal",
									textDecoration:
										checkForOverride(
											baseTheme,
											cue.type,
											cue.preset,
											"h2",
											"underline"
										) === true
											? "underline line-through"
											: `${item.checked ? "line-through" : "none"}`,
								}}
								className={`${baseThemeId}_${
									cue.type
								}_large_text large_text ${baseThemeId}_px
                    ${item.checked && "opacity-50"}
                    mb-s2
                    `}
							>
								<ReplaceWithDataSource text={item.body} styled={true} />
							</li>
						);
					})}
				</ol>
			</span>
		</>
	);
}
